// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticPointMap_container__5pb4z","map":"StaticPointMap_map__skQL2","static":"StaticPointMap_static___zvWP"};